import React from 'react';
import { Check, Star, Briefcase } from 'lucide-react';
import { Button } from './ui/button';
import { eventPackages } from '../data/mock';

export const EventPackagesSection = ({ onBookNow }) => {
  const colorClasses = {
    green: { border: 'border-green', glow: 'rgba(0, 255, 65, 0.3)', text: 'text-primary' },
    blue: { border: 'border-blue', glow: 'rgba(0, 217, 255, 0.3)', text: 'text-blue' },
    pink: { border: 'border-pink', glow: 'rgba(255, 0, 255, 0.3)', text: 'text-pink' }
  };

  return (
    <section className="py-24 bg-card relative overflow-hidden">
      <div className="absolute inset-0 cyber-grid opacity-20"></div>
      <div className="absolute inset-0" style={{
        background: 'radial-gradient(circle at 20% 50%, rgba(0, 255, 65, 0.08) 0%, transparent 40%), radial-gradient(circle at 80% 50%, rgba(255, 0, 255, 0.08) 0%, transparent 40%)'
      }}></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-page border-2 border-blue rounded-full mb-6" style={{ boxShadow: '0 0 20px rgba(0, 217, 255, 0.3)' }}>
            <Briefcase className="text-blue" size={20} />
            <span className="text-blue text-sm font-bold uppercase tracking-wider">Corporate & Group Events</span>
          </div>
          
          <h2 className="heading-2 text-5xl md:text-6xl font-black uppercase mb-4">
            <span className="text-primary" style={{ textShadow: '0 0 15px var(--neon-green)' }}>TEAM </span>
            <span className="text-blue" style={{ textShadow: '0 0 15px var(--neon-blue)' }}>BUILDING</span>
            <br />
            <span className="text-pink" style={{ textShadow: '0 0 15px var(--neon-pink)' }}>PACKAGES</span>
          </h2>
          
          <p className="body-medium text-white max-w-3xl mx-auto">
            Build stronger teams through immersive VR challenges, collaborative experiences, and unforgettable adventures. We handle everything so you can focus on your team!
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mb-12">
          {eventPackages.map((pkg) => {
            const colors = colorClasses[pkg.color];
            
            return (
              <div
                key={pkg.id}
                className={`bg-page border-2 ${colors.border} rounded-2xl overflow-hidden hover:scale-105 transition-all duration-300 relative`}
                style={{ boxShadow: `0 0 20px ${colors.glow}` }}
              >
                {pkg.popular && (
                  <div className="absolute top-4 right-4 z-10">
                    <div className="bg-blue px-3 py-1 rounded-full flex items-center gap-1" style={{ boxShadow: '0 0 15px rgba(0, 217, 255, 0.5)' }}>
                      <Star className="text-inverse fill-inverse" size={14} />
                      <span className="text-inverse text-xs font-bold uppercase">Popular</span>
                    </div>
                  </div>
                )}
                
                <div className="bg-accent p-6 border-b-2 border-current">
                  <h3 className={`text-2xl font-black ${colors.text} uppercase mb-2`}>{pkg.name}</h3>
                  <p className="text-secondary text-sm italic mb-4">{pkg.tagline}</p>
                  <div className="space-y-1 text-sm">
                    <p className="text-white font-semibold">{pkg.guests}</p>
                    <p className="text-secondary">{pkg.duration}</p>
                    <p className={`${colors.text} text-xs font-bold uppercase`}>{pkg.highlight}</p>
                  </div>
                </div>
                
                <div className="p-6">
                  <div className="space-y-3 mb-6">
                    {pkg.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <Check className={`${colors.text} flex-shrink-0 mt-0.5`} size={18} />
                        <span className="text-white text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                  
                  <Button 
                    onClick={onBookNow}
                    className={pkg.popular ? "btn-primary w-full font-bold" : "btn-secondary w-full font-bold"}
                    data-testid={`event-pkg-book-${pkg.id || pkg.name}`}
                  >
                    BOOK NOW
                  </Button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="bg-page border-2 border-blue rounded-2xl p-8 text-center" style={{ boxShadow: '0 0 20px rgba(0, 217, 255, 0.3)' }}>
          <h3 className="heading-4 text-blue font-bold uppercase mb-4">Need a Custom Package?</h3>
          <p className="text-white mb-6">
            Have a larger team or specific requirements? We can create a custom experience tailored to your organization's goals and budget!
          </p>
          <Button onClick={onBookNow} className="btn-secondary font-bold">
            CONTACT US FOR CUSTOM PACKAGES
          </Button>
        </div>
      </div>
    </section>
  );
};
